import { connect } from "react-redux";
import injectIntl from "../../../../../../common/helpers/injectIntl";

import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";

import TonesetStaff from "./lazy";

export default connect(null, { editTask, post })(injectIntl(TonesetStaff as any))